import { render, staticRenderFns } from "./GlobalConfirmBox.vue?vue&type=template&id=03a8854a"
import script from "./GlobalConfirmBox.vue?vue&type=script&lang=js"
export * from "./GlobalConfirmBox.vue?vue&type=script&lang=js"
import style0 from "./GlobalConfirmBox.vue?vue&type=style&index=0&id=03a8854a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports